//formatters

const formatter = {
    currency: (value) => new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
        }).format(value),
    date: (value) =>
        value && Object.prototype.toString.call(value) === '[object String]'
            ? value.replace(/(\d{4})-(\d{2})-(\d{2})/, '$2/$3/$1').split('T')[0]
            : '',
    dateForInput: (value) => {
        if (Object.prototype.toString.call(value) === '[object Date]')
            return value.toISOString().split('T')[0];
        if (Object.prototype.toString.call(value) === '[object String]')
            return value.split('T')[0];
    },
    dateTime: (value) =>
        value && Object.prototype.toString.call(value) === '[object String]' && value !== null
            ? value.replace(/(\d{4})-(\d{2})-(\d{2})/, '$2/$3/$1')
            : '',
    dateTimePretty: (value) => {
        if (!value) return '';
        let date = value;
        if (Object.prototype.toString.call(value) === '[object String]') {
            date = new Date(value);
        }
        return date.toLocaleString([],
            {
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
                hour: 'numeric',
                minute: '2-digit'
            }).replace(',', '');
    },
    dateTimeLocalEncoded: (value) =>
        value && Object.prototype.toString.call(value) === '[object Date]'
            ? dateToIsoLikeButLocal(value)
            : '',
    dateChangeLogFormat: (value) => {
        const date = new Date(value);
        return `${date.getFullYear()}/${(date.getMonth() < 9 ? '0' : '') + (date.getMonth() + 1)}/${(date.getDate() < 10 ? '0' : '') + date.getDate()}`;
    },
    timeChangeLogFormat: (value) => {
        const date = new Date(value);
        let hours = date.getHours();
        const minutes = date.getMinutes() < 10 ? `0${date.getMinutes().toString()}` : date.getMinutes().toString();
        let amPm = 'am';
        if (hours > 12) {
            amPm = 'pm';
            hours = hours - 12;
        }

        return `${hours}:${minutes}${amPm}`;
    },
    time: (value) =>
        value && Object.prototype.toString.call(value) === '[object Date]'
            ? value.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' })
            : '',
    percent: (value) => new Intl.NumberFormat('en-US', {
        style: 'percent',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(value/100)
}

function dateToIsoLikeButLocal(date) {
    const offsetMs = date.getTimezoneOffset() * 60 * 1000;
    const msLocal = date.getTime() - offsetMs;
    const dateLocal = new Date(msLocal);
    const iso = dateLocal.toISOString();
    const isoLocal = iso.slice(0, 19);
    return isoLocal;
}

export default formatter;